import { Content } from 'src/contexts/ContentContext';
import { PosDropdownItem } from 'src/core/POS/PosDropdown';
import { Stack } from 'src/core/ui';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import {
  useUserCanManageSeatSaver,
  useUserCanUpdateListing,
} from 'src/hooks/useUserHasListingPermissions';
import { ContentId } from 'src/utils/constants/contentId';
import { Feature } from 'src/WebApiController';

export const LaunchBulkUpdateSeatTraits = ({
  onClick,
  disabled,
}: {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}) => {
  const hasManageSeatSaverPermission = useUserCanManageSeatSaver();
  const hasRegularListingPermission = useUserCanUpdateListing(undefined, true);

  const hasSeatSaverFeature = useUserHasFeature(Feature.SeatSaver);
  if (
    (!hasManageSeatSaverPermission || !hasSeatSaverFeature) &&
    !hasRegularListingPermission
  ) {
    return null;
  }

  return (
    <>
      <PosDropdownItem
        key="update-seat-traits-event-inventory"
        onClick={onClick}
        disabled={disabled}
      >
        <Stack gap="m" alignItems="center" width="full">
          <Content id={ContentId.UpdateSeatTraits} />
        </Stack>
      </PosDropdownItem>
    </>
  );
};
